import { createSlice } from "@reduxjs/toolkit";

const ticketSlice = createSlice({
  name: "tickets",
  initialState: {
    loading: false,
    ticket: null,
    ticketData: [],
    ticketStatusHistory: null,
    comments: [],
    total: 0,
    error: null,
     instalaxmiAdmin: [],
  },
  reducers: {
    saveTicketRequest: (state) => {
      state.loading = true;
    },
    saveTicketSuccess: (state, action) => {
      state.loading = false;
      state.ticket = action.payload;
    },
    saveTicketFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getTicketsRequest: (state) => {
      state.loading = true;
    },
    getTicketsSuccess: (state, action) => {
      state.loading = false;
      state.ticketData = action?.payload?.data?.data;
      state.total = action?.payload?.data?.total;
    },
    getTicketsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateTicketStatusRequest: (state) => {
      state.loading = true;
    },

    updateTicketStatusSuccess: (state, action) => {
      state.loading = false;

      const updatedTicket = action.payload;

      state.ticketData = state.ticketData.map((ticket) =>
        ticket._id === updatedTicket._id ? updatedTicket : ticket,
      );
    },

    updateTicketStatusFailure: (state) => {
      state.loading = false;
    },
    getTicketStatusHistoryRequest: (state) => {
      state.loading = true;
    },

    getTicketStatusHistorySuccess: (state, action) => {
      state.loading = false;
      state.ticketStatusHistory = action.payload?.data || [];
    },

    getTicketStatusHistoryFailure: (state) => {
      state.loading = false;
    },
    assignTicketRequest: (state) => {
      state.loading = true;
    },

    assignTicketSuccess: (state, action) => {
      state.loading = false;

      const updatedTicket = action.payload;

      state.ticketData = state.ticketData.map((ticket) =>
        ticket._id === updatedTicket._id ? updatedTicket : ticket,
      );
    },

    assignTicketFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getCommentsRequest: (state) => {
      state.loading = true;
    },
    getCommentsSuccess: (state, action) => {
      state.loading = false;
      state.comments = action.payload?.data || [];
    },
    getCommentsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    saveCommentRequest: (state) => {
      state.loading = true;
    },
    saveCommentSuccess: (state, action) => {
      state.loading = false;
    },
    saveCommentFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

     fetchInstalaxmiAdminRequest: (state) => {
      state.loading = true;
      state.message = null;
      state.messageType = null;
    },
    fetchInstalaxmiAdminSuccess: (state, action) => {
      state.loading = false;
      state.instalaxmiAdmin = action.payload;
    },
    fetchInstalaxmiAdminFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
      state.messageType = action.payload.type;
    },
  },
});

export const {
  saveTicketRequest,
  saveTicketSuccess,
  saveTicketFailure,
  getTicketsRequest,
  getTicketsSuccess,
  getTicketsFailure,
  updateTicketStatusRequest,
  updateTicketStatusSuccess,
  updateTicketStatusFailure,
  getTicketStatusHistoryRequest,
  getTicketStatusHistorySuccess,
  getTicketStatusHistoryFailure,
  assignTicketRequest,
  assignTicketSuccess,
  assignTicketFailure,
  getCommentsRequest,
  getCommentsSuccess,
  getCommentsFailure,
  saveCommentRequest,
  saveCommentSuccess,
  saveCommentFailure,
  fetchInstalaxmiAdminRequest,
  fetchInstalaxmiAdminSuccess,
  fetchInstalaxmiAdminFailure,
} = ticketSlice.actions;

export default ticketSlice.reducer;
